var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckboxCheckedDisabled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_14144_213532)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 2,
    fill: "#BABABA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14144_213532)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.341 6.24452C13.4984 6.08845 13.711 6.00061 13.9327 6C14.1544 5.99939 14.3674 6.08605 14.5257 6.24125C14.684 6.39645 14.7748 6.60771 14.7786 6.82937C14.7824 7.05103 14.6988 7.26527 14.5459 7.42577L10.0549 13.0395C9.97769 13.1227 9.88453 13.1894 9.78097 13.2357C9.67741 13.282 9.56558 13.3069 9.45216 13.309C9.33874 13.3111 9.22605 13.2904 9.12085 13.2479C9.01565 13.2055 8.92009 13.1422 8.83988 13.062L5.86425 10.0853C5.78135 10.008 5.71486 9.91488 5.66875 9.81138C5.62263 9.70788 5.59783 9.59615 5.59583 9.48286C5.59384 9.36957 5.61468 9.25703 5.65711 9.15197C5.69955 9.04691 5.76271 8.95147 5.84283 8.87135C5.92295 8.79123 6.01839 8.72807 6.12345 8.68563C6.22851 8.6432 6.34105 8.62236 6.45434 8.62435C6.56763 8.62635 6.67936 8.65115 6.78286 8.69727C6.88635 8.74338 6.97951 8.80987 7.05675 8.89277L9.4125 11.2474L13.3196 6.26927C13.3266 6.26055 13.3341 6.25229 13.3421 6.24452H13.341Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_14144_213532",
    x: 0,
    y: 0,
    width: 20,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14144_213532"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14144_213532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 8,
    fill: "white",
    transform: "translate(5 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCheckedDisabled);
export default __webpack_public_path__ + "static/media/checkbox-checked-disabled.6e335d288148feb5f5c971eb650b6837.svg";
export { ForwardRef as ReactComponent };